import get from 'lodash/get';

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_NUMBER = 1;

export const HD_DEFAULT_PAGE_SIZE = 20;

export const getUrl = (
  URL: string,
  payload?: { limit: number; page: number; filter_status?: string; user_role?: string; user_status?: string }
) => {
  if (payload) {
    const keyValuePairs = Object.keys(payload)
      .reduce((acc: any, key) => {
        acc.push(key + '=' + encodeURIComponent(get(payload, key, '')));
        return acc;
      }, [])
      .join('&');

    return `${URL}?${keyValuePairs}`;
  }
  return URL;
};
